import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number | string;
}

const Tormoza: React.FC<IconProps> = ({
  color = "#2625e9",
  size = 40,
  className,
  style,
  ...props
}) => (
  <svg
    transform="scale(1.5)"
    viewBox="0 0 80 80"
    style={{ width: size, height: size, flexShrink: 0, ...style }}
    aria-hidden="true"
    className={className}
    {...props}
  >
<g transform="translate(0,0)">
    <path
      d="M20.26 37.86c-.14 0-.28-.04-.4-.11l-8.72-5.33a.765.765 0 01-.33-.89l1.43-4.46-1.38-2.57a.75.75 0 01.04-.79c1.45-2.13 3.07-4.17 4.82-6.06 2.16-2.33 4.54-4.47 7.09-6.37.27-.2.64-.2.91 0l2.09 1.53 5.06-2.17c.37-.16.79 0 .98.34l5 9.39c.11.21.12.46.02.67-.1.22-.28.38-.51.43-.45.12-.91.25-1.35.4-2.14.7-5.3 2.14-8.19 4.97-3.66 3.59-5.18 7.66-5.81 10.43a.765.765 0 01-.75.6zm-7.81-6.43l7.31 4.47c.8-2.9 2.47-6.73 5.97-10.16 3.1-3.04 6.49-4.58 8.79-5.33.17-.06.34-.11.52-.16l-4.22-7.92-4.81 2.07a.77.77 0 01-.76-.09l-1.99-1.45a50.213 50.213 0 00-6.43 5.84 50.813 50.813 0 00-4.41 5.5l1.31 2.44c.1.18.12.4.05.6l-1.35 4.2z"
      fill={color}
    />
    <path
      d="M24.19 37.5c-.08 0-.17-.01-.25-.04l-3.01-1.02c-.4-.14-.62-.57-.48-.97s.57-.62.97-.48l2.24.76c.61-1.96 1.77-4.55 3.98-6.98 2.55-2.8 5.46-4.25 7.7-5.01l-1.26-2.26a.773.773 0 01.3-1.05c.37-.21.84-.07 1.05.3l1.72 3.08c.11.21.13.45.04.67s-.28.38-.5.44c-2.13.6-5.23 1.92-7.91 4.85a16.857 16.857 0 00-3.85 7.12c-.05.21-.19.38-.38.48-.11.06-.24.09-.37.09zM40.92 53.62c-6.89 0-12.5-5.61-12.5-12.5s5.61-12.5 12.5-12.5 12.5 5.61 12.5 12.5-5.61 12.5-12.5 12.5zm0-23.46c-6.05 0-10.96 4.92-10.96 10.96s4.92 10.96 10.96 10.96 10.96-4.92 10.96-10.96-4.92-10.96-10.96-10.96z"
      fill={color}
    />
    <path
      d="M40.92 69.44c-15.61 0-28.31-12.7-28.31-28.31 0-2.65.37-5.28 1.09-7.8.07-.23.24-.42.46-.5.22-.09.48-.06.68.06l4.94 3.01c.8-2.9 2.47-6.73 5.97-10.16 3.1-3.04 6.49-4.58 8.79-5.33.17-.06.34-.11.52-.16l-2.74-5.14a.762.762 0 01-.03-.66c.09-.21.27-.37.49-.44 2.63-.79 5.38-1.19 8.15-1.19 15.61 0 28.31 12.7 28.31 28.31s-12.7 28.31-28.31 28.31zM14.91 34.73c-.51 2.08-.77 4.23-.77 6.4 0 14.76 12.01 26.78 26.78 26.78S67.7 55.9 67.7 41.13 55.69 14.35 40.92 14.35c-2.31 0-4.59.29-6.8.87l2.74 5.14c.11.21.12.46.02.67-.1.22-.28.38-.51.43-.45.12-.91.25-1.35.4-2.14.7-5.3 2.14-8.19 4.97-3.66 3.59-5.18 7.66-5.81 10.43-.05.24-.22.44-.45.54-.23.1-.49.08-.7-.05l-4.95-3.02z"
      fill={color}
    />
    <path
      d="M47.75 24.5c-.23 0-.45-.1-.61-.29-.26-.33-.2-.82.13-1.08l4.03-3.16c.33-.26.82-.2 1.08.13.26.33.2.82-.13 1.08l-4.03 3.16c-.14.11-.31.16-.47.16zM55.97 32.45c-.41 0-.75-.33-.77-.74-.01-.42.32-.78.74-.79l6.12-.2c.43 0 .78.32.79.74.01.42-.32.78-.74.79l-6.12.2h-.03zM63.77 46.28c-.15 0-.3-.04-.43-.13l-4.64-3.16a.77.77 0 01.87-1.27l4.64 3.16c.35.24.44.72.2 1.07a.77.77 0 01-.64.34zM56.53 58.83a.76.76 0 01-.74-.56l-1.58-5.66c-.11-.41.12-.83.53-.95.41-.11.83.12.95.53l1.58 5.66a.774.774 0 01-.74.98zM44.39 64.69c-.05 0-.11 0-.16-.02a.764.764 0 01-.59-.91l1.07-5c.09-.42.5-.68.91-.59.42.09.68.5.59.91l-1.07 5c-.08.36-.4.61-.75.61zM30.61 63.06c-.2 0-.4-.08-.55-.24a.782.782 0 01.02-1.09l3.77-3.62c.31-.29.79-.28 1.09.02.29.31.28.79-.02 1.09l-3.77 3.62c-.15.14-.34.21-.53.21zM19.49 52.09c-.4 0-.74-.32-.77-.72-.03-.42.3-.79.72-.81l6.02-.36c.43-.02.79.3.81.72.03.42-.3.79-.72.81l-6.02.36h-.05z"
      fill={color}
    />
    </g>
  </svg>
);

export default Tormoza;
